import { render, staticRenderFns } from "./IntegrationsModal.vue?vue&type=template&id=5282c48b&"
import script from "./IntegrationsModal.vue?vue&type=script&lang=js&"
export * from "./IntegrationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports